export type VerifyResult =
  | { ok: true }
  | {
      ok: false;
      error: "verification_unavailable" | "rate_limited" | "expired" | "bad_password" | "internal";
      retryAfterSeconds?: number;
    };

// Same-origin proxy path served by functions/api/edge/[[path]].ts (prod)
// and vite.config.ts server.proxy (dev). Keeping these fetches same-origin
// is what lets Set-Cookie from the edge functions land on map.bordeciel.com
// so `document.cookie` on the app origin can read bcdl_jwt.
const FUNCTIONS = "/api/edge";

export async function verifySharePassword(input: {
  slug: string;
  password: string;
  turnstile: string;
}): Promise<VerifyResult> {
  const r = await fetch(FUNCTIONS + "/share_password_verify", {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      slug: input.slug,
      password: input.password,
      turnstile_token: input.turnstile,
    }),
  });
  if (r.status === 500) return { ok: false, error: "internal" };
  const body = await r.json();
  if (body.ok) return { ok: true };
  return {
    ok: false,
    error: body.error,
    retryAfterSeconds: typeof body.retry_after_seconds === "number" ? body.retry_after_seconds : undefined,
  };
}

export async function remintSession(): Promise<boolean> {
  const r = await fetch(FUNCTIONS + "/share_session_remint", {
    method: "POST",
    credentials: "include",
  });
  return r.status === 204;
}

export function signOutViewer(): void {
  document.cookie = "bcdl_jwt=; Max-Age=0; Path=/";
  document.cookie = "bcdl_session=; Max-Age=0; Path=/";
}
